import { render, staticRenderFns } from "./DOTSPatientAdd.vue?vue&type=template&id=73a2a843&scoped=true"
import script from "./DOTSPatientAdd.vue?vue&type=script&lang=js"
export * from "./DOTSPatientAdd.vue?vue&type=script&lang=js"
import style0 from "./DOTSPatientAdd.vue?vue&type=style&index=0&id=73a2a843&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a2a843",
  null
  
)

export default component.exports